import React, { useEffect, useState, useRef } from 'react';
import { CSVLink } from 'react-csv';
import DataTable from 'react-data-table-component';
import {
    GET_DMT_TRANS_REPORT,
    POST_DMT_FAIL_TRANSACTION,
    POST_DMT_REINITIATE_TRANSACTION,
    GET_DMT_TRANSACTION_INQUIRY,
    POST_DMT_INSTANT_PAY_RE_INITIATE_TRANSACTION,
} from './../../../Utils/appConstants';
import {
    dmtStatus, dmtStatusExport, dmtDetailStatus, dmtStatusInArray,
    dmtModeInArray, channelStatus
} from './../../../Utils/Common';
import { getRequest, postRequest } from './../../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { DatePicker, Tooltip, Table, Space, Tag, Select } from 'antd';
import {
    FilterOutlined,
    SearchOutlined,
    ClearOutlined,
    DownloadOutlined,
    StopOutlined,
} from '@ant-design/icons';
import { getUTCToLocalDateTimeFormat, toDayDate, queryDate, getExportFormat } from '../../../Utils/function';
import PropagateLoader from "react-spinners/PropagateLoader";
import moment from 'moment';

/* ============================================================
   MODERN STYLES (scoped) — identical to AePS / FundTransfer
============================================================ */
const reportStyles = `
.aeps-page {
    padding: 16px 24px 40px;
    background: #f5f7fb;
    min-height: calc(100vh - 60px);
}
.aeps-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    flex-wrap: wrap;
    gap: 12px;
}
.aeps-page-title {
    font-size: 22px;
    font-weight: 700;
    color: #1f2a44;
    margin: 0;
    letter-spacing: 0.2px;
}
.aeps-page-title span { color: #e5484d; }
.aeps-page-subtitle {
    font-size: 13px;
    color: #6b7280;
    margin: 2px 0 0;
}

.aeps-card {
    background: #ffffff;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(16,24,40,.04), 0 4px 16px rgba(16,24,40,.06);
    border: 1px solid #eef0f4;
    overflow: hidden;
}
.aeps-card + .aeps-card { margin-top: 18px; }

.aeps-card-head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px 20px;
    border-bottom: 1px solid #f0f2f6;
    background: linear-gradient(180deg, #fbfcfe 0%, #ffffff 100%);
}
.aeps-card-head-title {
    font-size: 13px;
    font-weight: 600;
    color: #344054;
    text-transform: uppercase;
    letter-spacing: .6px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
}
.aeps-card-head-title .anticon {
    color: #5851D2;
    font-size: 14px;
}

.aeps-filter-body { padding: 18px 20px 20px; }

.aeps-filter-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 14px 16px;
    align-items: end;
}

.aeps-field { display: flex; flex-direction: column; min-width: 0; }
.aeps-field label {
    font-size: 11.5px;
    font-weight: 600;
    color: #667085;
    text-transform: uppercase;
    letter-spacing: .4px;
    margin-bottom: 6px;
}

.aeps-field-span-2 { grid-column: span 2; }

.aeps-field .ant-picker,
.aeps-field .ant-select,
.aeps-field .aeps-input {
    width: 100%;
    height: 40px;
    border-radius: 10px;
    border: 1px solid #e4e7ec;
    background: #fff;
    transition: border-color .15s, box-shadow .15s;
    font-size: 13.5px;
}
.aeps-field .ant-picker { padding: 0 11px; }
.aeps-field .ant-picker input { font-size: 13.5px; }
.aeps-field .ant-select .ant-select-selector {
    height: 40px !important;
    border-radius: 10px !important;
    border: 1px solid #e4e7ec !important;
    padding: 0 11px !important;
}
.aeps-field .ant-select-single .ant-select-selector .ant-select-selection-item,
.aeps-field .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 38px !important;
    font-size: 13.5px;
}
.aeps-field .ant-select-multiple .ant-select-selector {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
}
.aeps-field .ant-picker:hover,
.aeps-field .ant-select:hover .ant-select-selector,
.aeps-field .aeps-input:hover { border-color: #c7cbd3 !important; }
.aeps-field .ant-picker-focused,
.aeps-field .ant-select-focused .ant-select-selector,
.aeps-field .aeps-input:focus {
    border-color: #5851D2 !important;
    box-shadow: 0 0 0 3px rgba(88,81,210,.12) !important;
    outline: none;
}

.aeps-input {
    padding: 0 12px;
    color: #101828;
    outline: none;
}
.aeps-input::placeholder { color: #98a2b3; }

/* Actions now live IN row 2, spanning 2 columns (4 buttons, wrap-friendly) */
.aeps-filter-grid .aeps-actions {
    grid-column: span 2;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 8px;
    min-height: 40px;
}

/* Compact padding so 4 buttons fit in span-2 on standard screens */
.aeps-filter-grid .aeps-actions .aeps-btn {
    padding: 0 14px;
    font-size: 13px;
}

.aeps-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    border-radius: 10px;
    border: 1px solid transparent;
    font-weight: 600;
    cursor: pointer;
    transition: transform .08s, box-shadow .15s, background .15s, border-color .15s;
    white-space: nowrap;
}
.aeps-btn:active { transform: translateY(1px); }

.aeps-btn-primary {
    background: linear-gradient(180deg, #6b64e0 0%, #5851D2 100%);
    color: #fff;
    box-shadow: 0 2px 6px rgba(88,81,210,.35);
}
.aeps-btn-primary:hover { box-shadow: 0 4px 12px rgba(88,81,210,.45); }

.aeps-btn-ghost {
    background: #ffffff;
    color: #475467;
    border-color: #e4e7ec;
}
.aeps-btn-ghost:hover { background: #f9fafb; border-color: #cfd4dc; }

.aeps-btn-success {
    background: #ffffff;
    color: #0e9384;
    border-color: #b7e4dd;
}
.aeps-btn-success:hover { background: #f0fdfa; border-color: #0e9384; }

.aeps-btn-danger {
    background: #fee4e2;
    color: #b42318;
    border-color: #fecdca;
}
.aeps-btn-danger:hover { background: #fecdca; border-color: #b42318; }
.aeps-btn-danger:disabled {
    background: #f2f4f7;
    color: #98a2b3;
    border-color: #e4e7ec;
    cursor: not-allowed;
    opacity: 0.7;
    box-shadow: none;
}

.aeps-table-wrap { padding: 4px 6px 10px; }
.aeps-table-wrap .rdt_TableHeadRow {
    background: #f9fafb !important;
    border-bottom: 1px solid #eef0f4 !important;
    min-height: 46px !important;
}
.aeps-table-wrap .rdt_TableCol {
    font-size: 11.5px !important;
    font-weight: 700 !important;
    color: #475467 !important;
    text-transform: uppercase !important;
    letter-spacing: .4px !important;
}
.aeps-table-wrap .rdt_TableRow {
    border-bottom: 1px solid #f2f4f7 !important;
    min-height: 52px !important;
    transition: background .15s;
}
.aeps-table-wrap .rdt_TableRow:hover { background: #fafbff !important; }
.aeps-table-wrap .rdt_TableCell { font-size: 13px !important; color: #344054 !important; }
.aeps-table-wrap .rdt_Pagination {
    border-top: 1px solid #eef0f4 !important;
    background: #fff !important;
    min-height: 52px !important;
}

/* Medium desktops: tighten buttons further so 4 fit without wrapping */
@media (min-width: 1024px) and (max-width: 1400px) {
    .aeps-filter-grid .aeps-actions { gap: 6px; }
    .aeps-filter-grid .aeps-actions .aeps-btn {
        padding: 0 10px;
        font-size: 12.5px;
    }
}

/* Below 1024px: auto-fit grid, actions full width, span-2 reset */
@media (max-width: 1023px) {
    .aeps-filter-grid {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
    .aeps-field-span-2 { grid-column: auto; }
    .aeps-filter-grid .aeps-actions {
        grid-column: 1 / -1;
        margin-top: 6px;
        padding-top: 16px;
        border-top: 1px dashed #eef0f4;
        justify-content: flex-end;
    }
}

@media (max-width: 640px) {
    .aeps-page { padding: 12px; }
    .aeps-filter-grid .aeps-actions { justify-content: center; }
    .aeps-filter-grid .aeps-actions .aeps-btn {
        flex: 1 1 auto;
        justify-content: center;
        padding: 0 12px;
    }
}
`;

/* ============================================================
   PERSISTENCE HELPERS
============================================================ */
const FILTERS_STORAGE_KEY = 'dmtHistoryReportFilters';
const RESTORE_FLAG_KEY = 'dmtHistoryReportRestore';

const consumeRestoreFlag = () => {
    try {
        const flag = sessionStorage.getItem(RESTORE_FLAG_KEY);
        if (flag === '1') {
            sessionStorage.removeItem(RESTORE_FLAG_KEY);
            return true;
        }
    } catch { /* ignore */ }
    return false;
};

const loadSavedFilters = () => {
    if (!consumeRestoreFlag()) {
        try { sessionStorage.removeItem(FILTERS_STORAGE_KEY); } catch { /* ignore */ }
        return {};
    }
    try {
        const raw = sessionStorage.getItem(FILTERS_STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

const restoreDate = (str) => {
    if (!str) return toDayDate();
    const m = moment(str, 'DD-MM-YYYY');
    return m.isValid() ? m : toDayDate();
};

/* ============================================================
   API PROVIDER HELPER
   - main row: uses client_ref_id (e.g. IMA2610012149S05602 → IMW)
   - sub row:  uses transactionId (e.g. SI2610012142Z05593 → IP)
============================================================ */
const getApiProvider = (row) => {
    const txId = String(row?.client_ref_id || row?.transactionId || '');
    if (/^IM/i.test(txId)) return 'IMW';
    if (/^(SI|SN|SJ)/i.test(txId)) return 'IP';
    return '-';
};

/* ============================================================ */

function DmtHistoryReport(props) {

    const history = useHistory();
    const csvLink = useRef();
    const limit = 10;
    const dateFormat = 'DD-MM-YYYY';

    const [saved] = useState(() => loadSavedFilters());

    const [searchUserId, setSearchUserId] = useState(saved.searchUserId ?? '');
    const [searchAccountNumber, setSearchAccountNumber] = useState(saved.searchAccountNumber ?? '');
    const [searchTransId, setSearchTransId] = useState(saved.searchTransId ?? '');
    const [searchCustomerId, setSearchCustomerId] = useState(saved.searchCustomerId ?? '');
    const [searchStatus, setSearchStatus] = useState(saved.searchStatus ?? null);
    const [searchMode, setSearchMode] = useState(saved.searchMode ?? null);

    const [isLoading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(restoreDate(saved.endDate));
    const [startDate, setStartDate] = useState(restoreDate(saved.startDate));
    const [getData, setData] = useState({ docs: [] });
    const [getCsvData, setCsvData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(saved.page || 1);
    const [isLimit, setLimit] = useState(saved.isLimit || limit);
    const [userId, setUserId] = useState(props.userId);
    const [isChecked, setChecked] = useState([]);
    const [invoiceData, setInvoiceData] = useState(null);

    // Fetch driver
    const [fetchTrigger, setFetchTrigger] = useState(0);
    const [tableResetKey, setTableResetKey] = useState(0);

    /* ---------------------------------------------------------
       Checkbox selection (used by Fail Transaction)
    --------------------------------------------------------- */
    const onClick = (event) => {
        const { checked, value } = event.target;
        if (checked) {
            setChecked([...isChecked, value]);
        } else {
            setChecked(isChecked.filter(item => item !== value));
        }
    };

    /* ---------------------------------------------------------
       Invoice navigation (preserves session restore flag)
    --------------------------------------------------------- */
    const handleInvoice = (data) => {
        try { sessionStorage.setItem(RESTORE_FLAG_KEY, '1'); } catch { /* ignore */ }
        setInvoiceData(data);
        history.push(`/dmtinvoice/${data.client_ref_id}`);
    };

    // ============================================================
    //  COLUMNS  (API Provider added after Mode)
    // ============================================================
    const columns = [
        {
            name: 'Date Time',
            cell: row => getUTCToLocalDateTimeFormat(row.createdAt),
            width: '200px',
        },
        {
            name: 'Trans ID',
            selector: row => (
                <Tooltip placement="bottom" title={row.client_ref_id}>{row.client_ref_id}</Tooltip>
            ),
            width: '180px',
        },
        {
            name: 'Amount',
            selector: row => `${row.amount} ${row.currency}`,
            width: '110px',
        },
        {
            name: 'Status',
            selector: row => dmtStatus(row.txtStatus),
            width: '140px',
        },
        {
            name: 'Mode',
            selector: row => channelStatus(row.channel),
            width: '110px',
        },
        {
            name: 'API Provider',
            selector: row => getApiProvider(row),
            width: '130px',
            center: true,
        },
        {
            name: 'Customer ID',
            selector: row => <Tooltip placement="bottom" title={row.customer_id}>{row.customer_id}</Tooltip>,
            width: '130px',
        },
        {
            name: 'Partner ID',
            selector: row => <Tooltip placement="bottom" title={row.users && row.users.username}>{row.users && row.users.username}</Tooltip>,
            width: '130px',
        },
        {
            name: 'Bank Name',
            selector: row => (row.baneData && row.baneData.bankName) || (row.baneData1 && row.baneData1.bankName),
            width: '220px',
        },
        {
            name: 'IFSC Code',
            selector: row => row.ifsccode,
            width: '120px',
        },
        {
            name: 'Account Number',
            selector: row => row.accountNumber,
            width: '170px',
        },
        {
            name: 'Bene Name',
            selector: row =>
                row.baneData?.beneBankName || row.baneData1?.beneBankName ||
                row.baneData1?.beneName || row.baneData?.beneName || '',
            width: '190px',
        },
        {
            name: 'Action',
            selector: row => (
                <button
                    type="button"
                    className="btn btn-sm border border-success text-success"
                    onClick={() => handleInvoice(row)}
                    title="Print Invoice"
                >
                    <i className="fa fa-print" aria-hidden="true"></i>
                </button>
            ),
            width: '100px',
        },
        {
            name: 'Message',
            selector: row => <Tooltip placement="bottom" title={row.message}>{row.message}</Tooltip>,
            width: '200px',
            headerStyle: () => ({ textAlign: 'center' }),
        },
    ];

    // ============================================================
    //  FETCH
    // ============================================================
    const getDataReports = () => {
        setLoading(true);
        const params = { page, limit: isLimit };

        if (startDate) params.startDate = queryDate(startDate);
        if (endDate) params.endDate = queryDate(endDate);
        if (props.userId) params.userId = userId || props.userId;

        params.searchAccountNumber = searchAccountNumber || '';
        params.searchCustomerId = searchCustomerId || '';
        params.searchTransId = searchTransId || '';
        params.searchUserId = searchUserId || '';
        params.searchStatus = searchStatus ? searchStatus : '';
        params.searchMode = searchMode || '';

        const queryString = objectToQueryString(params);
        getRequest(`${GET_DMT_TRANS_REPORT}?${queryString}`, history)
            .then((response) => {
                if (response.success === true && response.data) {
                    setData(response.data);
                    setTotalRecord(response.data.totalDocs || 0);
                    if (typeof response.data.page === 'number') setPage(response.data.page);
                } else {
                    setData({ docs: [] });
                    setTotalRecord(0);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setData({ docs: [] });
                setTotalRecord(0);
                setLoading(false);
            });
    };

    useEffect(() => {
        getDataReports();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchTrigger]);

    // ============================================================
    //  CSV EXPORT  (API Provider added)
    // ============================================================
    const getCSVDataList = () => {
        const params = { exportsCsv: true };
        if (startDate && endDate) {
            params.startDate = queryDate(startDate);
            params.endDate = queryDate(endDate);
        }
        if (props.userId) params.userId = userId || props.userId;

        params.searchAccountNumber = searchAccountNumber || '';
        params.searchCustomerId = searchCustomerId || '';
        params.searchTransId = searchTransId || '';
        params.searchUserId = searchUserId || '';
        params.searchStatus = searchStatus ? searchStatus : '';
        params.searchMode = searchMode || '';

        const queryString = objectToQueryString(params);
        getRequest(`${GET_DMT_TRANS_REPORT}?${queryString}`, history)
            .then((response) => {
                if (response.success === true) {
                    const csvdataRecord = (response.data || []).map((e) => ({
                        'Date Time': getExportFormat(e.createdAt),
                        'Trans ID': e.client_ref_id,
                        'Amount': e.amount,
                        'Status': dmtStatusExport(e.txtStatus),
                        'Mode': channelStatus(e.channel),
                        'API Provider': getApiProvider(e),
                        'Customer Id': e.customer_id,
                        'Partner Id': e.users && e.users.username,
                        'Bank Name': (e.baneData && e.baneData.bankName) || (e.baneData1 && e.baneData1.bankName),
                        'IFSC Code': e.ifsccode,
                        'Account Number': e.accountNumber,
                        'Bene Name': (e?.baneData?.beneName ?? e?.baneData1?.beneName ?? '').replaceAll('.', ''),
                        'Message': e.message,
                    }));
                    setCsvData(csvdataRecord);
                    setTimeout(() => {
                        if (csvLink.current && csvLink.current.link) {
                            csvLink.current.link.click();
                        }
                    }, 1000);
                } else {
                    setCsvData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    // ============================================================
    //  FAIL / REINITIATE / INQUIRY (preserved)
    // ============================================================
    const failTransaction = () => {
        if (isChecked.length > 0) {
            postRequest(`${POST_DMT_FAIL_TRANSACTION}`, isChecked, history)
                .then((response) => {
                    if (response.success === true) {
                        getDataReports();
                        toast.success(response.message);
                        setChecked([]);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        } else {
            toast.error('Minimum one record is selected');
        }
    };

    const handleSubmit = (data) => {
        setLoading(true);
        const payload = { transactionId: data.client_ref_id };
        let URL = '';
        if (data.client_ref_id.includes('SI') || data.apiName === 'Instant Pay') {
            URL = POST_DMT_INSTANT_PAY_RE_INITIATE_TRANSACTION;
        } else {
            URL = POST_DMT_REINITIATE_TRANSACTION;
        }
        postRequest(`${URL}`, payload, history)
            .then((response) => {
                if (response.success === true) {
                    toast.success(response.message);
                    getDataReports();
                } else {
                    toast.error(response.message);
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const transactionInquiry = (data) => {
        setLoading(true);
        const payload = { transactionId: data.transactionId };
        const URL = GET_DMT_TRANSACTION_INQUIRY;
        postRequest(`${URL}`, payload, history)
            .then((response) => {
                if (response.success === true) {
                    toast.success(response.message);
                    getDataReports();
                } else {
                    toast.error(response.message);
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    // ============================================================
    //  HELPERS
    // ============================================================
    const objectToQueryString = (obj) => {
        const str = [];
        for (const p in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
            }
        }
        return str.join('&');
    };

    // ============================================================
    //  HANDLERS
    // ============================================================
    const resetToFirstPageAndFetch = () => {
        setPage(1);
        setTableResetKey((k) => k + 1);
        setFetchTrigger((k) => k + 1);
    };

    const handlePageChange = (newPage /*, size */) => {
        setPage(newPage);
        setFetchTrigger((k) => k + 1);
    };

    const handleRowsPerPageChange = (newLimit) => {
        setLimit(newLimit);
        resetToFirstPageAndFetch();
    };

    const handleSearch = () => resetToFirstPageAndFetch();

    const handleClear = () => {
        try {
            sessionStorage.removeItem(FILTERS_STORAGE_KEY);
            sessionStorage.removeItem(RESTORE_FLAG_KEY);
        } catch { /* ignore */ }

        setStartDate(toDayDate());
        setEndDate(toDayDate());
        setSearchAccountNumber('');
        setSearchTransId('');
        setSearchCustomerId('');
        setSearchUserId('');
        setSearchStatus(null);
        setSearchMode(null);
        setChecked([]);
        resetToFirstPageAndFetch();
    };

    const onChangeStartDate = (date) => setStartDate(date);
    const onChangeEndDate = (date) => setEndDate(date);
    const onChangeType = (value) => setSearchStatus(value);
    const onChangeTypeMode = (value) => setSearchMode(value);

    // ============================================================
    //  PERSIST FILTERS ON CHANGE
    // ============================================================
    useEffect(() => {
        const toSave = {
            startDate: startDate ? moment(startDate).format(dateFormat) : null,
            endDate: endDate ? moment(endDate).format(dateFormat) : null,
            searchUserId,
            searchAccountNumber,
            searchTransId,
            searchCustomerId,
            searchStatus,
            searchMode,
            page,
            isLimit,
        };
        try {
            sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(toSave));
        } catch { /* ignore */ }
    }, [
        startDate, endDate,
        searchUserId, searchAccountNumber, searchTransId, searchCustomerId,
        searchStatus, searchMode, page, isLimit,
    ]);

    useEffect(() => {
        if (props.userId) setUserId(props.userId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ============================================================
    //  EXPANDABLE SUB-ROW (checkboxes + API Provider)
    // ============================================================
    const ExpandableComponent = (rowProps, key) => (
        <div className="ml-5 w-75 py-2">
            <Table
                dataSource={rowProps.data.dmttransactiondetails}
                key={key}
                pagination={false}
                size="small"
                columns={[
                    {
                        title: '#',
                        render: (record) => (
                            <input
                                type="checkbox"
                                className="pointer"
                                onChange={onClick}
                                checked={isChecked.includes(record._id)}
                                disabled={
                                    record.isInsufficientFund &&
                                    (record.tx_status === null ||
                                        record.tx_status === '-1' ||
                                        record.tx_status === '8')
                                        ? false
                                        : true
                                }
                                value={record._id}
                            />
                        ),
                    },
                    {
                        title: 'Transaction Id',
                        dataIndex: 'transactionId',
                        key: 'transactionId',
                    },
                    {
                        title: 'API Provider',
                        key: 'apiProvider',
                        render: (record) => getApiProvider(record),
                    },
                    {
                        title: 'Amount',
                        dataIndex: 'amount',
                        key: 'amount',
                    },
                    {
                        title: 'Bank RRN',
                        dataIndex: 'bank_ref_num',
                        key: 'bank_ref_num',
                    },
                    {
                        title: 'T ID',
                        dataIndex: 'tid',
                        key: 'tid',
                    },
                    {
                        title: 'Status',
                        key: 'txstatus_desc',
                        render: (record, k) => (
                            <Space key={k} size="middle">{dmtDetailStatus(record.tx_status)}</Space>
                        ),
                    },
                    {
                        title: 'Action',
                        key: 'action',
                        render: (record, k) => (
                            <Space key={k} size="middle">
                                {!record.isRefund &&
                                    ['0', '1', '2', '3', '5', '-1', '8'].includes(record.tx_status) && (
                                        <Tag
                                            color="yellow"
                                            onClick={() => transactionInquiry(record)}
                                            className="pointer"
                                            style={{ borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
                                        >
                                            INQUIRY
                                        </Tag>
                                    )}
                            </Space>
                        ),
                    },
                    {
                        title: 'Message',
                        dataIndex: 'reason',
                        key: 'reason',
                    },
                ]}
            />
        </div>
    );

    // ============================================================
    //  RENDER
    // ============================================================
    return (
        <div className="aeps-page">
            <style>{reportStyles}</style>

            {/* <div className="aeps-page-header">
                <div>
                    <h1 className="aeps-page-title">
                        Money Transfer <span>Report</span>
                    </h1>
                    <p className="aeps-page-subtitle">
                        Search, filter, and export DMT transactions
                    </p>
                </div>
            </div> */}

            {/* ─── Filters card — 2 rows ──────────────────────── */}
            <div className="aeps-card">
                {/* <div className="aeps-card-head">
                    <h2 className="aeps-card-head-title">
                        <FilterOutlined /> Filters
                    </h2>
                </div> */}

                <div className="aeps-filter-body">
                    <div className="aeps-filter-grid">
                        {/* ════════ ROW 1 — 6 fields ════════ */}
                        <div className="aeps-field">
                            <label>From Date</label>
                            <DatePicker
                                value={startDate}
                                format={dateFormat}
                                onChange={onChangeStartDate}
                                placeholder="From date"
                            />
                        </div>

                        <div className="aeps-field">
                            <label>To Date</label>
                            <DatePicker
                                value={endDate}
                                format={dateFormat}
                                onChange={onChangeEndDate}
                                placeholder="To date"
                            />
                        </div>

                        <div className="aeps-field">
                            <label>User ID</label>
                            <input
                                type="text"
                                className="aeps-input"
                                placeholder="Enter User ID"
                                onChange={(e) => setSearchUserId(e.target.value)}
                                value={searchUserId || ''}
                            />
                        </div>

                        <div className="aeps-field">
                            <label>Trans ID</label>
                            <input
                                type="text"
                                className="aeps-input"
                                placeholder="Enter Trans ID"
                                onChange={(e) => setSearchTransId(e.target.value)}
                                value={searchTransId || ''}
                            />
                        </div>

                        <div className="aeps-field">
                            <label>A/C Number</label>
                            <input
                                type="text"
                                className="aeps-input"
                                placeholder="Enter A/C number"
                                onChange={(e) => setSearchAccountNumber(e.target.value)}
                                value={searchAccountNumber || ''}
                            />
                        </div>

                        <div className="aeps-field">
                            <label>Customer ID</label>
                            <input
                                type="text"
                                className="aeps-input"
                                placeholder="Enter Customer ID"
                                onChange={(e) => setSearchCustomerId(e.target.value)}
                                value={searchCustomerId || ''}
                            />
                        </div>

                        {/* ════════ ROW 2 — Mode(2) + Status(2) + Actions(2) ════════ */}
                        <div className="aeps-field aeps-field-span-2">
                            <label>Mode</label>
                            <Select
                                options={dmtModeInArray}
                                value={searchMode || undefined}
                                className="normal-light"
                                classNamePrefix="select"
                                placeholder="Select mode"
                                name="mode"
                                onChange={onChangeTypeMode}
                                allowClear
                            />
                        </div>

                        <div className="aeps-field aeps-field-span-2">
                            <label>Status</label>
                            <Select
                                mode="multiple"
                                options={dmtStatusInArray}
                                value={searchStatus || undefined}
                                className="normal-light"
                                classNamePrefix="select"
                                placeholder="Select status"
                                name="status"
                                onChange={onChangeType}
                                maxTagCount="responsive"
                                allowClear
                            />
                        </div>

                        {/* Actions — right-aligned, span 2 cols, wraps if needed */}
                        <div className="aeps-actions">
                            <button type="button" className="aeps-btn aeps-btn-ghost" onClick={handleClear}>
                                <ClearOutlined /> Clear
                            </button>

                            <button type="button" className="aeps-btn aeps-btn-success" onClick={getCSVDataList}>
                                <DownloadOutlined /> Export CSV
                            </button>

                            <button type="button" className="aeps-btn aeps-btn-primary" onClick={handleSearch}>
                                <SearchOutlined /> Search
                            </button>

                            <button
                                type="button"
                                className="aeps-btn aeps-btn-danger"
                                disabled={isChecked.length === 0}
                                onClick={failTransaction}
                                title={isChecked.length === 0 ? 'Select at least one sub-transaction to fail' : ''}
                            >
                                <StopOutlined /> Fail Transaction{isChecked.length > 0 ? ` (${isChecked.length})` : ''}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ─── Table card ─────────────────────────────────── */}
            <div className="aeps-card">
                <div className="aeps-table-wrap">
                    <DataTable
                        key={tableResetKey}
                        title=""
                        columns={columns}
                        data={getData.docs || []}
                        defaultSortFieldId={1}
                        highlightOnHover
                        pagination
                        paginationServer
                        expandableRows
                        expandableRowsComponent={ExpandableComponent}
                        progressPending={isLoading}
                        progressComponent={
                            <div className="text-center py-4">
                                <PropagateLoader color="#5851D2" size={20} />
                            </div>
                        }
                        paginationTotalRows={getTotalRecord}
                        paginationDefaultPage={page}
                        paginationPerPage={isLimit}
                        onChangeRowsPerPage={handleRowsPerPageChange}
                        onChangePage={handlePageChange}
                        noDataComponent={
                            <div style={{ padding: '40px 20px', color: '#98a2b3', fontSize: 13 }}>
                                No records found for the selected filters.
                            </div>
                        }
                    />
                </div>
            </div>

            <CSVLink
                data={getCsvData}
                filename="money-transfer-report"
                className="hidden"
                ref={csvLink}
                target="_blank"
                style={{ display: 'none' }}
            />
        </div>
    );
}

export default DmtHistoryReport;